import { useCallback, useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { useAffiliateGoods } from '../queries/useAffiliateGoods';
import { useGoodsDetail } from '../queries/useGoodsDetail';
import { bridge, isNotNil } from 'shared/src/utils';
import { useLogGoodsAnalyticsEvent } from './useLogGoodsAnalyticsEvent';
import { affiliateGoodsFloatingAtom } from '../atom/affiliateFloating.atom';

export const useAffiliateFloating = () => {
  const [hasShownFloating, setHasShownFloating] = useAtom(
    affiliateGoodsFloatingAtom,
  );

  const { data: affiliateGoods } = useAffiliateGoods();
  const { data: goodsDetail } = useGoodsDetail();
  const logEvent = useLogGoodsAnalyticsEvent();
  const [showFloating, setShowFloating] = useState(false);

  useEffect(() => {
    if (
      isNotNil(affiliateGoods) &&
      affiliateGoods.floating_title &&
      affiliateGoods.floating_title.length > 0 &&
      !hasShownFloating
    ) {
      setShowFloating(true);
    }
  }, [affiliateGoods, hasShownFloating]);

  const onViewFloating = useCallback(() => {
    setHasShownFloating(true);
  }, [setHasShownFloating]);

  const onClickFloating = useCallback(() => {
    if (!isNotNil(goodsDetail) || !isNotNil(affiliateGoods)) return;

    logEvent({
      name: 'CLICK_FLOATING_BUTTON',
      analytics: affiliateGoods.logging ?? {},
    });

    setShowFloating(false);

    bridge.openGoodsShare({
      is_by_screenshot: false,
      goods_sno: goodsDetail.goods.sno,
      affiliate_reward: {
        expected_reward: affiliateGoods.expected_reward,
        share_nudging: affiliateGoods.share_nudging ?? null,
        logging: affiliateGoods.logging ?? null,
      },
    });
  }, [affiliateGoods, goodsDetail, logEvent]);

  return {
    floatingText: affiliateGoods?.floating_title ?? '',
    showFloating,
    onViewFloating,
    onClickFloating,
  };
};
